import { useRouteLoaderData } from 'react-router'
import { type loader as rootLoader } from '../routes/_marketing+/_search-api+/_layout'

export function useDataDropdown() {
  const data = useRouteLoaderData<typeof rootLoader>('routes/_marketing+/_search-api+/_layout')
  const province = (data?.listProvince || []).map((item:any) => {
    return {
      label: item.name,
      value: item.id
    }
  })
  const category = (data?.listCategory || []).map((item:any) => {
    return {
      label: item.name,
      value: item.id
    }
  })

  const listArea = (data?.listArea || []).map((item:any) => {
    return {
      label: item.label,
      value: String(item.key)
    }
  })
  const listPrice = (data?.listPrice || []).map((item: any) => {
    return {
      label: item.label,
      value: String(item.key)
    }
  })
  return {
    province,
    category,
    listArea,
    listPrice
  }
}
